import { LabelLarge, useStyletron } from '@visualfabriq/vf-ui-kit';

export function StepHeader({ title }: { title: string }) {
  const [css] = useStyletron();
  return <LabelLarge className={css({ flex: '0 1 auto' })}>{title}</LabelLarge>;
}
